<template>
  <v-card class="rounded-lg" :loading="loading" v-intersect="intersect">
    <v-row>
      <v-col cols="12" sm="4" :style="bgStyle" class="rounded-lg">
        <div style="position: relative">
          <v-img
            :src="party.cover"
            class="rounded-lg"
            :aspect-ratio="16 / 9"
            style="cursor: pointer"
            :style="{
              filter: !item.isActive ? `grayscale(80%)` : undefined,
            }"
            @click="management(item)"
          >
          </v-img>

          <div
            class="d-flex flex-column align-start gap-1"
            style="position: absolute; top: 8px; left: 8px"
          >
            <v-chip label x-small :color="item.private ? 'info' : 'success'">
              <v-icon x-small left>
                {{ item.private ? "mdi-account-lock" : "mdi-account-group" }}
              </v-icon>
              <span>
                {{ item.private ? "Privado" : "Público" }}
              </span>
            </v-chip>
          </div>
          <div
            class="d-flex flex-column align-start gap-1"
            style="position: absolute; top: 8px; right: 8px"
          >
            <base-copier type="chip" :value="item.id || ''" hide-icon>
              <template v-slot:default="{ copy, icon }">
                <v-chip
                  @click="copy"
                  small
                  label
                  class="text-overline font-weight-medium"
                >
                  #{{ item.id | shortId }}
                  <v-icon right x-small>{{ icon }}</v-icon>
                </v-chip>
              </template>
            </base-copier>
          </div>
        </div>

        <!-- ParentParty -->
        <v-card
          v-if="party.ParentParty"
          class="d-flex align-center mt-2 gap-2 rounded-lg"
          elevation="0"
          @click="scrollToEvent(party.ParentParty.id)"
          outlined
        >
          <div>
            <v-img
              height="40"
              :width="40 * (16 / 9)"
              :src="party.ParentParty.cover"
              class="rounded-l-lg"
              :aspect-ratio="16 / 9"
            />
          </div>
          <div class="d-flex flex-column">
            <span class="text-overline lh-1" style="font-size: 8px !important">
              Evento principal
            </span>
            <h6 class="mb-0 text-12">{{ party.ParentParty.name }}</h6>
          </div>
        </v-card>

        <v-card
          v-if="party.Organization"
          class="d-flex align-center mt-2 gap-2 pa-1 rounded-lg"
          elevation="0"
          outlined
        >
          <div>
            <base-avatar
              :src="party.Organization.photo"
              :seed="party.Organization.id"
              :size="30"
              avatarStyle="shapes"
              color="secondary lighten-2"
            />
          </div>
          <div style="display: grid">
            <span class="text-overline lh-1" style="font-size: 8px !important">
              Organização
            </span>
            <h6 class="mb-0 text-12 text-truncate">
              {{ party.Organization.name }}
            </h6>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="">
        <div class="d-flex flex-column h-full">
          <div class="d-flex justify-space-between align-center gap-2">
            <span class="ma-0 text-overline" style="line-height: 1em">
              {{ item.date | date("DD [de] MMM [de] YYYY") }} •
              {{ item.Organization.Platform.name }}
            </span>

            <v-chip v-if="!item.isActive" label x-small>
              <span v-if="item.status === 'finished'">Encerrado</span>
              <span v-else>Inativo</span>
            </v-chip>
            <v-chip v-else :color="dataDiference.color" label x-small>
              {{
                dataDiference.text.charAt(0).toUpperCase() +
                dataDiference.text.slice(1)
              }}
            </v-chip>
          </div>
          <h5 class="ma-0">
            {{ item.name }}
          </h5>
          <v-divider class="my-2" />

          <party-onboarding :item="item" />

          <v-spacer />

          <div class="d-flex flex-wrap align-end gap-1 mt-2">
            <v-btn
              :to="`//${item.Organization.Platform.domain}/shop/${
                item.Organization.slug
              }/${item.slug || item.id}`"
              target="_blank"
              color="primary"
              text
              small
            >
              Ver Evento <v-icon right small>mdi-open-in-new</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn :to="`/admin/parties/${item.id}`" color="primary">
              Gerenciar
            </v-btn>
          </div>
        </div>
        <!-- <party-quick-report
          v-if="hasPermission(512, item.id)"
          :party="item"
          class="mx-1"
        /> -->
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import moment from "moment";
import PartyStatus from "@/utils/partyStatus";
import { mapGetters } from "vuex";
import PartyOnboarding from "./modules/PartyOnboarding.vue";
// import PartyQrCode from "./PartyQrCode.vue";
// import PartyQuickReport from "./PartyQuickReport.vue";

export default {
  components: { PartyOnboarding },
  data: () => ({
    visible: false,
  }),
  // components: { PartyQrCode, PartyQuickReport },
  methods: {
    scrollToEvent(id) {
      this.$vuetify.goTo(`#party-${id}`, {
        duration: 500,
        offset: 0,
      });
    },
    management(party) {
      this.$router.push({
        name: "admin.parties.management",
        params: { id: party.id },
      });
    },
    intersect(entries) {
      if (entries[0].isIntersecting) this.visible = true;
    },
  },
  computed: {
    ...mapGetters("auth", ["hasPermission", "config"]),
    ...mapGetters("organization", ["selectedOrganization"]),
    dataDiference() {
      if (!this.item?.endDate) return { text: "Sem data", color: "error" };
      if (moment().isBefore(this.item.date)) {
        const duration = moment.duration(moment(this.item.date).diff(moment()));
        return {
          text: duration.humanize(true),
          color: "success",
        };
      } else if (moment().isBefore(this.item.endDate)) {
        return {
          text: "Em andamento",
          color: "warning",
        };
      } else {
        return {
          text: "Encerrado",
          color: "error",
        };
      }
    },
    bgStyle() {
      if (!this.visible) return null;
      if (!this.party.cover) return null;

      const color = this.$vuetify.theme.dark ? "#1e1e1e" : "#fff";
      const isXs = this.$vuetify.breakpoint.xsOnly;
      return {
        "background-size": "cover",
        backgroundImage: `linear-gradient(to ${
          isXs ? "bottom" : "right"
        },transparent 0%, ${color} 100%),
          url("${this.party.cover}")`,
        "background-repeat": "no-repeat",
      };
    },
    item() {
      const status = new PartyStatus(this.party);
      return {
        ...this.party,
        status: status.status,
        isActive: status.isActive,
      };
    },
  },
  props: {
    party: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss"></style>
